import React from 'react';
import { Link } from 'react-router-dom';

type LinkWrapperProps = {
  children: React.ReactNode;
  url: string;
  className?: string;
  style?: React.CSSProperties;
  target?: '_self' | '_blank';
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  onMouseEnter?: React.MouseEventHandler<HTMLAnchorElement>;
  onMouseLeave?: React.MouseEventHandler<HTMLAnchorElement>;
  replace?: boolean;
};

const LinkWrapper = React.forwardRef<HTMLAnchorElement, LinkWrapperProps>(({
 children, url, className = '', style, target = '_self', onClick, onMouseEnter, onMouseLeave, replace
}, ref) => {
  // Check if URL is a full URL (starts with http:// or https://)
  const isFullUrl = url.startsWith('http://') || url.startsWith('https://');

  // Internal deeplink chips always open in a new tab (same as other sharables).
  // Absolute URLs already default to _blank when target is _self; relative SPA
  // paths must also honour an explicit _blank so React Router does not navigate in-place.
  const resolvedTarget = target === '_self' && isFullUrl ? '_blank' : target;

  // If it's a full URL, use regular anchor tag
  if (isFullUrl) {
    return (
      <a
        href={url}
        className={className}
        style={style}
        target={resolvedTarget}
        rel="noopener noreferrer"
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        ref={ref}
      >
        {children}
      </a>
    );
  }

  // For relative paths, use React Router Link
  return (
    <Link
      to={url}
      className={className}
      style={style}
      target={resolvedTarget}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      ref={ref}
      replace={replace}
    >
      {children}
    </Link>
);
});

LinkWrapper.displayName = 'LinkWrapper';

export default LinkWrapper;
